module.exports = __webpack_public_path__ + "static/media/Sunkern_gaussian2.1c9bf741.png";